import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import { combineClasses, combineProps, hasValue, styled, useThemeProps, } from '../../../foundation';
import { RcMenu } from '../../Menu/Menu';
import { RcVirtualizedMenu } from '../../VirtualizedMenu';
import { SelectArrowDownIcon, selectStyle } from './styles';
import { RcSelectClasses, RcSelectInputClasses, RcSelectInputClassesMap, RcSelectInputWhenPlaceholderClasses, RcSelectTextField, SelectInput, } from './utils';
var leftBottomAnchorOrigin = {
    horizontal: 'left',
    vertical: 'bottom',
};
/** @release */
var _RcSelect = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcSelect' });
    var children = props.children, onChange = props.onChange, defaultValue = props.defaultValue, SelectInputPropsProp = props.SelectInputProps, MenuProps = props.MenuProps, textVariant = props.textVariant, placeholder = props.placeholder, renderValue = props.renderValue, displayEmpty = props.displayEmpty, variant = props.variant, size = props.size, value = props.value, virtualize = props.virtualize, 
    // * below is should pick into TextField props
    focused = props.focused, gutterBottom = props.gutterBottom, helperText = props.helperText, color = props.color, label = props.label, id = props.id, className = props.className, title = props.title, validate = props.validate, InputProps = props.InputProps, required = props.required, fullWidth = props.fullWidth, disabled = props.disabled, error = props.error, rest = __rest(props, ["children", "onChange", "defaultValue", "SelectInputProps", "MenuProps", "textVariant", "placeholder", "renderValue", "displayEmpty", "variant", "size", "value", "virtualize", "focused", "gutterBottom", "helperText", "color", "label", "id", "className", "title", "validate", "InputProps", "required", "fullWidth", "disabled", "error"]);
    var hasDefaultValue = hasValue(defaultValue);
    var nonValue = (!hasValue(value) && !hasDefaultValue) ||
        // * if that can't displayEmpty, and that value === '', same as no value
        (!displayEmpty && value === '');
    var applyClasses = useMemo(function () {
        var variantClasses = RcSelectInputClassesMap[variant];
        return combineClasses(RcSelectInputClasses, variantClasses);
    }, [variant]);
    var _SelectProps = useMemo(function () {
        var additionProps = {
            MenuComponent: undefined,
            MenuProps: undefined,
        };
        if (rest === null || rest === void 0 ? void 0 : rest.multiple) {
            additionProps.MenuComponent = RcMenu;
            additionProps.MenuProps = {
                anchorOrigin: leftBottomAnchorOrigin,
            };
        }
        if (virtualize) {
            additionProps.MenuComponent = RcVirtualizedMenu;
            additionProps.MenuProps = {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                transformOrigin: { horizontal: 0, vertical: 8 },
            };
        }
        additionProps.MenuProps = combineProps(additionProps.MenuProps, MenuProps);
        return __assign({ renderValue: renderValue, classes: combineClasses(RcSelectClasses, rest === null || rest === void 0 ? void 0 : rest.classes), IconComponent: SelectArrowDownIcon, displayEmpty: displayEmpty, inputComponent: SelectInput, inputProps: __assign(__assign(__assign({}, additionProps), rest === null || rest === void 0 ? void 0 : rest.inputProps), SelectInputPropsProp) }, rest);
    }, [
        rest,
        virtualize,
        renderValue,
        displayEmpty,
        SelectInputPropsProp,
        MenuProps,
    ]);
    var _InputProps = useMemo(function () {
        var result = InputProps;
        if (placeholder && nonValue) {
            result = combineProps({
                classes: combineClasses(RcSelectInputWhenPlaceholderClasses, applyClasses),
                disableUnderline: variant === 'box',
            }, result);
        }
        return combineProps({
            classes: applyClasses,
        }, result);
    }, [InputProps, placeholder, nonValue, applyClasses, variant]);
    var valueIsNumber = typeof value === 'number';
    var currValue = valueIsNumber ? value : value || '';
    return (React.createElement(RcSelectTextField, { ref: ref, id: id, className: className, title: title, 
        // for when that is select type that type will be select onChange, just any for ignore that
        onChange: onChange, color: color, select: true, focused: focused, gutterBottom: gutterBottom, helperText: helperText, label: label, 
        // when that has defaultValue, and that value always to be undefined
        value: hasDefaultValue ? undefined : currValue, defaultValue: defaultValue, validate: validate, required: required, fullWidth: fullWidth, disabled: disabled, error: error, InputProps: _InputProps, clearBtn: false, placeholder: placeholder, SelectProps: _SelectProps }, children));
});
var RcSelect = styled(_RcSelect)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), selectStyle);
RcSelect.displayName = 'RcSelect';
RcSelect.defaultProps = {
    size: 'medium',
    variant: 'line',
};
export { RcSelect };
var templateObject_1;
